import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Clarity",
    body: "Cut through complexity with focused, strategic thinking that identifies the core of every challenge before you act.",
  },
  {
    n: "02",
    title: "Discipline",
    body: "Build systematic approaches to leadership that create consistency and reliability under pressure — every single time.",
  },
  {
    n: "03",
    title: "Resilience",
    body: "Develop the mental fortitude to navigate uncertainty and emerge stronger from every challenge you face.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Approach() {
  return (
    <section id="approach" className="relative py-28 sm:py-40 border-t border-white/10" data-testid="approach">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex items-baseline gap-4 mb-20">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-primary">/ The Protocol</span>
          <span className="h-px flex-1 bg-white/10" />
        </div>

        <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-none max-w-3xl mb-24">
          A calm hand on the <span className="text-primary">wire.</span> Our approach to leadership under pressure.
        </h2>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="group relative bg-background p-8 sm:p-10 min-h-[340px] flex flex-col justify-between hover:bg-card transition-colors duration-300"
              data-testid={`approach-chapter-${c.n}`}
            >
              <span className="font-mono text-7xl sm:text-8xl font-bold text-white/5 group-hover:text-primary/20 transition-colors duration-500">
                {c.n}
              </span>
              <div>
                <h3 className="font-display font-bold uppercase text-2xl mb-4 tracking-tight">
                  {c.title}
                </h3>
                <p className="text-foreground/60 leading-relaxed text-[15px]">{c.body}</p>
              </div>
              <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-primary group-hover:w-full transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
